export default __webpack_public_path__ + "static/media/Info-background.8b18aaba.svg";